import { LANDING_ENABLED } from '../../../config/constants';

export const REGISTER_PATH = '/register';
export const LOGIN_PATH = '/login';
/** Listagem pública de planos (usada quando a landing está desligada, ex.: app.salespetro). */
export const PLANS_PATH = '/planos';

export {
  SALESPETRO_LOGO_HEIGHT,
  SALESPETRO_LOGO_PATH,
  SALESPETRO_LOGO_WIDTH,
  SALESPETRO_LOGO_WORDMARK_PATH,
} from '../../../constants/branding';

export const SALESPETRO_CONTACT_EMAIL = 'comercial@petrofull.com.br';

export const SALESPETRO_TAGLINE =
  'Indicadores, cotações e comparação de preços para quem compra combustível todo dia.';

export const LANDING_ANCHORS = {
  terminal: 'terminal',
  dados: 'dados',
  planos: 'planos',
  faq: 'faq',
  contato: 'contato',
} as const;

/**
 * Destino para escolher plano antes do cadastro.
 * Com landing: âncora `#planos`. Sem landing (app.salespetro): página `/planos`.
 */
export const getLandingPlansPath = (): string =>
  LANDING_ENABLED ? `/#${LANDING_ANCHORS.planos}` : PLANS_PATH;

export const TICKER_BRANDS = ['VIBRA', 'RAÍZEN', 'IPIRANGA', 'ALE'] as const;

export const FUEL_SERIES_COLORS = {
  ethanol: '#389e0d',
  gasoline: '#d4760a',
  diesel: '#0958d9',
} as const;

export const FAQ_ITEMS = [
  {
    key: '1',
    question: 'O que é o Sales Petro?',
    answer:
      'É o sistema da Petrofull para acompanhar o mercado de combustíveis, cotar com distribuidoras e comparar preços — tudo em um só lugar, pensado para postos e equipes de compra.',
  },
  {
    key: '2',
    question: 'O que eu consigo fazer no sistema?',
    answer:
      'Ver indicadores de etanol, biodiesel e derivados; acompanhar variações de preço; consultar relatórios de mercado; solicitar cotações; comparar ofertas e simular a rentabilidade da compra.',
  },
  {
    key: '3',
    question: 'Posso testar antes de assinar?',
    answer:
      'Sim. Escolha um plano pago e teste por 7 dias grátis, sem cartão. O Starter libera a plataforma sem IA; o Essencial inclui resumos inteligentes; o Premium inclui IA na compra, cotação e Meu Posto.',
  },
  {
    key: '4',
    question: 'Como contrato o plano completo?',
    answer:
      'Na landing, escolha o plano e clique em "Escolher plano". Você pode testar 7 dias ou assinar direto. Também pode falar com o comercial para planos sob medida.',
  },
  {
    key: '5',
    question: 'Quem pode usar?',
    answer:
      'Postos, redes e gestores de compra que querem deixar a planilha para trás e tomar decisão com dados reais de mercado.',
  },
] as const;

const LANDING_ANCHOR_EVENT = 'landing-anchor-request';
const pendingAnchorIds = new Set<string>();

/** Força montagem de secções lazy antes do scroll (navbar da landing). */
export const requestLandingAnchor = (id: string) => {
  pendingAnchorIds.add(id);
  window.dispatchEvent(new CustomEvent<{ id: string }>(LANDING_ANCHOR_EVENT, { detail: { id } }));
};

export const isLandingAnchorPending = (id: string): boolean => {
  if (!pendingAnchorIds.has(id)) return false;
  pendingAnchorIds.delete(id);
  return true;
};

export const scrollToAnchor = (id: string) => {
  requestLandingAnchor(id);

  const tryScroll = (attempt = 0) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (attempt < 24) {
      window.requestAnimationFrame(() => tryScroll(attempt + 1));
    }
  };

  tryScroll();
};
